import { DateTime } from 'luxon';
export const getTimezoneAbbreviation = (ianaTimeZoneCode) => {
    const now = DateTime.now();
    const locale = getLocaleForTimezoneAbbreviation(ianaTimeZoneCode);
    const rezoned = now.setZone(ianaTimeZoneCode).setLocale(locale);
    return rezoned.toFormat('ZZZZ');
};
const getLocaleForTimezoneAbbreviation = (ianaTimeZoneCode) => {
    if (ianaTimeZoneCode.includes('Hong_Kong')) {
        return 'en-HK';
    }
    if (ianaTimeZoneCode.includes('Europe')) {
        return 'en-GB';
    }
    return 'en-US';
};
